import React from "react";
import Swal from "sweetalert2";

const Contact = () => {
  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    formData.append("access_key", "e1a70ff1-0550-487f-81dc-d825aad4594f");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      Swal.fire({
        title: "Success!",
        text: "Form Submitted Successfully!",
        icon: "success",
        timer: 1500,
      });
      event.target.reset();
    }
  };

  return (
    <div
      name="contact"
      className="bg-gradient-to-b from-black to-gray-800 p-4 text-white md:h-auto"
    >
      <div className="flex flex-col p-4 justify-center max-w-screen-lg mx-auto w-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Contact
          </p>
          <p className="py-6">GET IN TOUCH</p>
        </div>

        <div className=" flex justify-center items-center">
          <form
            onSubmit={onSubmit}
            method="POST"
            className=" flex flex-col w-full md:w-1/2"
          >
            <input
              type="hidden"
              name="from_name"
              value="Career Portfolio"
            ></input>
            <input
              type="text"
              name="name"
              required
              placeholder="Enter your name"
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="email"
              name="email"
              required
              placeholder="Enter your email"
              className="my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <input
              type="text"
              name="subject"
              required
              placeholder="Subject"
              className="p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            />
            <textarea
              name="message"
              required
              placeholder="Enter your message"
              rows="10"
              className="my-4 p-2 bg-transparent border-2 rounded-md text-white focus:outline-none"
            ></textarea>
            <button className="text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6 py-3 my-8 mx-auto flex items-center rounded-md hover:scale-110 duration-300">
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;